import { NavLink, useNavigate } from 'react-router-dom'
import { useSession } from '../../lib/useSession'
import Logo from './Logo'
import ThemeToggle from './ThemeToggle'

/**
 * The header shares the hero's royal field, so the top of the page reads as
 * one band. White on `#1E40AF` is 8.72:1; the sign-in control is accent-600
 * with white text (4.69:1) and a white outline to mark its edge on the blue.
 *
 * It wraps rather than holding one row, so every control stays reachable at
 * 320px without a menu pattern.
 */
const control =
  'rounded-md border-2 border-white bg-[var(--color-accent-600)] px-4 py-2 text-sm font-bold text-white hover:bg-[var(--color-accent-700)]'

export default function SiteHeader() {
  const { state, signOut } = useSession()
  const navigate = useNavigate()

  return (
    <header className="bg-[var(--color-royal)] text-white">
      <div className="page-shell flex flex-wrap items-center justify-between gap-x-4 gap-y-2 py-3">
        <NavLink to="/" aria-label="Hackathon home" className="flex min-w-0 items-center gap-3">
          <Logo className="size-11" />
          <span className="text-xl font-black tracking-tight">Hackathon</span>
        </NavLink>

        <div className="flex shrink-0 items-center gap-2">
          <ThemeToggle tone="inverse" />
          {state.status === 'signed-in' && state.session.role === 'admin' && (
            <NavLink
              to="/admin"
              className="rounded-md border-2 border-white px-4 py-2 text-sm font-bold text-white hover:bg-white/15"
            >
              Admin
            </NavLink>
          )}
          {state.status === 'signed-in' ? (
            <button
              type="button"
              className={control}
              onClick={async () => {
                await signOut()
                navigate('/')
              }}
            >
              Sign out
            </button>
          ) : (
            <NavLink to="/participant" className={control}>
              Sign in
            </NavLink>
          )}
        </div>
      </div>
    </header>
  )
}
